import { render, staticRenderFns } from "./FormularioETMI.vue?vue&type=template&id=c5c932a0&scoped=true"
import script from "./FormularioETMI.vue?vue&type=script&lang=js"
export * from "./FormularioETMI.vue?vue&type=script&lang=js"
import style0 from "./FormularioETMI.vue?vue&type=style&index=0&id=c5c932a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c932a0",
  null
  
)

export default component.exports